import {DropdownSelect} from "@common/ui-components/dropdown-select/dropdown-select";
import {stateToSelect} from "@common/ui-components/form/state-to-select";

export const DataLabelPositionSelect = (state) =>
    DropdownSelect({
        registryRender: true,
        label: "Position",
        list: ["Outside Above", "Outside Right", "Inside Middle", "Inside Bottom", "Inside Top", "Inside Right"].map((label) => ({
            label,
            value: label.replace(/ /g, ""),
        })),
        ...stateToSelect(state, ["value"]),
        valueToLabel: (v) => v.label,
    });
